import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';
import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import Notification from "../../components/Notifications/Notification";
import icon from '../../assets/images/icon.svg';
import dashboardIcon from '../../assets/images/dashboard.svg';
import settingsIcon from '../../assets/images/settings.svg';
import supportIcon from '../../assets/images/support.svg';
import featuredIcon from '../../assets/images/featured.svg';
import notificationIcon from '../../assets/images/notification.svg';
import programmelabIcon from '../../assets/images/pl_logo.svg';
import './Header.scss';
export default function Header() {
    const [info, setInfo] = useState(null);   
    useEffect(() => {
        const fetchInfo = async () => {
            try {
                const response = await apiFetch({ path: '/ultimate-security/v1/plugin-info' });
        
                // Save to localStorage
                localStorage.setItem("plusInfo", JSON.stringify(response));
        
                // Update state
                setInfo(response);
            } catch (error) {
                console.error("Error fetching info:", error);
            }
        };
        
        // Check if data is already in localStorage
        const storedInfo = localStorage.getItem("plusInfo");
        if (storedInfo) {
            setInfo(JSON.parse(storedInfo));
        } else {
            fetchInfo();
        }
    }, []);
     // Toggle notifications panel
     const [showNotifications, setShowNotifications] = useState(false);

    // Toggle notifications panel
    const toggleNotifications = (e) => {
        e.preventDefault();
        setShowNotifications(!showNotifications);
    };

    return (
        <div className="usfw-topbar background-purple-90 text-white">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-xl-5 mb-3 mb-xl-0">
                        <div className="d-flex justify-content-center justify-content-lg-start align-items-center topbar-left">
                            <img className="plugin-logo" src={icon}/>
                            <div className="plugin-name pl-heading fw-700">{__( 'Ultimate Security', "ultimate-security" )}</div>
                            <ul className="d-flex align-items-center mb-0 gap-3 mt-2">
                                { <li className="pl-heading-1 fw-600 dashboard-link">
                                    <Link to="/">
                                        <img src={dashboardIcon} alt="plugin-icon"/>
                                        {__( 'Dashboard', "ultimate-security" )}
                                    </Link>
                                </li> }
                                <li className="pl-heading-1 fw-600">
                                    <Link to="/login/temporary-login/create">
                                        <img src={settingsIcon} alt="plugin-icon"/>
                                        {__( 'Settings', "ultimate-security" )}
                                    </Link>
                                </li>
                            </ul>
                        </div>                        
                    </div>
                    <div className="col-xl-7">
                        <div className="row g-0 justify-content-center justify-content-lg-end align-items-center topbar-right">                                
                            <div className="col-auto header-logos">
                                <a href="https://wordpress.org/support/plugin/ultimate-security/" target="_blank">
                                <img src={supportIcon} alt="plugin-icon"/>
                                </a>
                            </div>
                            <div className="col-auto header-logos">
                                <a href="https://wordpress.org/support/plugin/ultimate-security/reviews/#new-post" target="_blank">
                                    <img src={featuredIcon} alt="plugin-icon"/>
                                </a>
                            </div>
                            <div className="col-auto header-logos">
                                <a
                                    href="#"
                                    onClick={toggleNotifications}
                                    className={`nav-link ${showNotifications ? "active" : ""}`}
                                >
                                     <img src={notificationIcon} alt="plugin-icon"/>
                                </a>
                                
                                {showNotifications && (
                                    <Notification onClose={() => setShowNotifications(false)} />
                                )}
                            </div>
                            <div className="col-auto topbar-right-unit">
                                <a href="https://www.programmelab.com" target="_blank">
                                    <img className="question" src={programmelabIcon}/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>                    
            </div>
        </div>
    )
}
